import React from 'react';
import { useSessionTimeout } from '@/hooks/useSessionTimeout';

/**
 * Invisible component that activates the session inactivity timeout.
 * Must be rendered inside AuthProvider.
 */
export const SessionTimeoutWrapper: React.FC = () => {
  useSessionTimeout();
  return null;
};
